import React, { useState, useEffect } from 'react';
import { useHeaderScale } from '../blueplanitUtils/useHeaderScale';

const ZONES = [
  { tz: 'America/New_York',    std: 'EST', dst: 'EDT', color: '#ffffff' },  // white
  { tz: 'America/Chicago',     std: 'CST', dst: 'CDT', color: '#fde047' },  // bright yellow
  { tz: 'America/Denver',      std: 'MST', dst: 'MDT', color: '#fdba74' },  // light orange
  { tz: 'America/Los_Angeles', std: 'PST', dst: 'PDT', color: '#86efac' },  // mint green
  { tz: 'Asia/Kolkata',        std: 'IST', dst: 'IST', color: '#f0abfc' },  // soft pink-purple
];

function getUTCOffset(date, tz) {
  const utc   = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const local = new Date(date.toLocaleString('en-US', { timeZone: tz }));
  return (local - utc) / 60000;
}

function isInDST(tz) {
  const now = new Date();
  const jan = new Date(now.getFullYear(), 0, 1);
  const jul = new Date(now.getFullYear(), 6, 1);
  const stdOffset = Math.min(getUTCOffset(jan, tz), getUTCOffset(jul, tz));
  return getUTCOffset(now, tz) !== stdOffset;
}

function getTimeInZone(tz) {
  return new Date().toLocaleTimeString('en-US', {
    timeZone: tz,
    hour:     '2-digit',
    minute:   '2-digit',
    hour12:   true,
  });
}

const WorldClock = () => {
  const scale = useHeaderScale();
  const [times, setTimes] = useState([]);

  const refresh = () => {
    setTimes(
      ZONES.map(z => ({
        label: isInDST(z.tz) ? z.dst : z.std,
        time:  getTimeInZone(z.tz),
        color: z.color,
      }))
    );
  };

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <li
      className="nav-item"
      style={{
        display:    'flex',
        alignItems: 'center',
        gap:        `${10 * scale}px`,
        padding:    `0 ${8 * scale}px`,
        height:     '100%',
        position:   'relative',
      }}
    >
      {times.map(({ label, time, color }) => (
        <div
          key={label}
          style={{
            display:        'flex',
            flexDirection:  'column',
            alignItems:     'center',
            justifyContent: 'center',
            gap:            '1px',
          }}
        >
          <span
            style={{
              fontSize:      `${7 * scale}px`,
              fontWeight:    800,
              color:         color,
              letterSpacing: `${0.8 * scale}px`,
              textTransform: 'uppercase',
              lineHeight:    1,
              opacity:       0.85,
            }}
          >
            {label}
          </span>
          <span
            style={{
              fontSize:      `${10 * scale}px`,
              fontWeight:    700,
              color:         color,
              whiteSpace:    'nowrap',
              lineHeight:    1,
              letterSpacing: `${0.2 * scale}px`,
            }}
          >
            {time}
          </span>
        </div>
      ))}

      {/* Separator after IST, vertically centered */}
      <span
        style={{
          display:         'block',
          width:           '1px',
          height:          `${22 * scale}px`,
          background:      'rgba(255,255,255,0.35)',
          borderRadius:    '2px',
          alignSelf:       'center',
          flexShrink:      0,
        }}
      />
    </li>
  );
};

export default WorldClock;
